import { render, staticRenderFns } from "./SlotView.vue?vue&type=template&id=35b13033&"
import script from "./SlotView.vue?vue&type=script&lang=ts&"
export * from "./SlotView.vue?vue&type=script&lang=ts&"
import style0 from "./SlotView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports